"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDateDots = void 0;
/**
 * Formats a given timestamp to a specific date format.
 * - If number is 0 or not a number or length of number is less than 8 it will return null.
 * - If the length is 8 or more, returns in the format `MM.DD.YYYY`.
 *
 * @param {number} value - The value to be formatted.
 * @returns {string} - The formatted date, or original/empty string based on conditions.
 */
const getFormattedDateDots = (value) => {
    const len = Math.ceil(Math.log10(value + 1));
    if (value === 0 || len < 8) {
        return "N/A";
    }
    return new Date(value * 1000)
        .toLocaleString("en-US")
        .split(",")[0]
        .replace(/\//g, ".");
};
exports.getFormattedDateDots = getFormattedDateDots;
